import { render, staticRenderFns } from "./ModificacionActivos.vue?vue&type=template&id=602b2ce0"
import script from "./ModificacionActivos.vue?vue&type=script&lang=js"
export * from "./ModificacionActivos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports